'use strict';

var $ = require('../internals/export');

var arrayWith = require('../internals/array-with');

var toIndexedObject = require('../internals/to-indexed-object');

var $Array = Array; // `Array.prototype.with` method
// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with

$({
  target: 'Array',
  proto: true
}, {
  'with': function _with(index, value) {
    return arrayWith(toIndexedObject(this), $Array, index, value);
  }
});